import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { SearchInput, Checkbox, Input } from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import { validaSoloNumero } from "../../../../util/varios";
import CatalogoMotivoDesincorporacion from "../../../../catalogos/catalogoMotivoDesincorporacion";
const op = require("../../../../modulos/datos");

export default function MotivosDesincorporacion({ show, setShow, setTabla }) {
  const token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtId = useRef();
  const txtCodigo = useRef();
  const txtDescripcion = useRef();
  const chkAfectaConta = useRef();

  const [operacion, setOperacion] = useState(0);
  const [txtOperacion, setTxtOperacion] = useState("");
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const blanquear = () => {
    txtId.current.value = "";
    txtCodigo.current.value = "";
    txtDescripcion.current.value = "";
    chkAfectaConta.current.checked = false;

    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabled(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
  };

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigo") {
        txtDescripcion.current.focus();
      } else if (e.target.name === "descripciondesincorporacion") {
        btnAcepta.current.focus();
      }
    }
  };

  const seleccionaregistro = async () => {
    const campos = "*";
    const id = txtId.current.value;
    const nomtab = "motivodesincorporacion";
    const nomid = "idmotivodesincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtCodigo.current.value = data.codigo.trim();
            txtDescripcion.current.value =
              data.descripciondesincorporacion.trim();
            chkAfectaConta.current.checked = data.afectaconta;
            setDisabled(operacion !== 2);
          } else {
            txtCodigo.current.value = "";
            txtDescripcion.current.value = "";
            chkAfectaConta.current.checked = false;
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un motivo de incorporacion con ese codigo.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/motivodesincorporacion/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let msm = "";
          if (operacion === 1) {
            msm =
              "registro " +
              response.data.motivodesincorporacion_act +
              " creado correctamente";
          } else if (operacion === 2) {
            msm =
              "registro " +
              response.data.motivodesincorporacion_act +
              " modificado correctamente";
          } else if (operacion === 3) {
            msm =
              "registro " +
              response.data.motivodesincorporacion_act +
              " eliminado correctamente";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msm,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "motivodesincorporacion_pkey"`
        ) {
          mensaje = "Ya Existe un motivo de desincorporacion con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const onChangeValidar = async () => {
    let sigue = true;

    if (operacion !== 1 && txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el id.`,
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    } else if (txtCodigo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el codigo.`,
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la Descripcion.`,
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    }

    if (sigue) {
      const datos = {
        operacion: operacion,
        idmotivodesincorporacion:
          txtId.current.value === "" ? 0 : txtId.current.value,
        codigo: txtCodigo.current.value.trim(),
        descripciondesincorporacion: txtDescripcion.current.value
          .trim()
          .toUpperCase(),
        afectaconta: chkAfectaConta.current.checked,
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtId.current.blur();
        seleccionaregistro();
      } else {
        txtCodigo.current.value = "";
        txtDescripcion.current.value = "";
        chkAfectaConta.current.checked = false;
      }
    }
  };

  const onHideCatalogo = (value = false) => {
    setMostrarCatalogo(false);
    if (value) {
      txtId.current.value = value.idmotivodesincorporacion;
      seleccionaregistro();
    }
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      setDisabled(false);
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 2) {
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtId.current.focus();
      }, 200);
    } else if (value === 3) {
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtId.current.focus();
      }, 200);
    } else if (value === 4) {
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtId.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Motivos de Desincorporacion del Bien {txtOperacion}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-2 m-0 mb-2 p-0">
          <SearchInput
            ref={txtId}
            disabled={operacion < 2}
            onKeyUp={validarCodigo}
            onBlur={validarCodigo}
            label="ID:"
            name="idmotivodesincorporacion"
            onClickButton={() => setMostrarCatalogo(true)}
            disabledButton={operacion < 2}
          />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input
            ref={txtCodigo}
            disabled={disabled}
            onChange={onChange}
            onKeyUp={onNextChange}
            maxLength={2}
            label="Codigo:"
            name="codigo"
          />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Input
            ref={txtDescripcion}
            disabled={disabled}
            onChange={onChange}
            onKeyUp={onNextChange}
            label="Descripción:"
            name="descripciondesincorporacion"
            style={{ height: 70 }}
          />
        </div>
        <div className="col-auto m-0 p-0">
          <Checkbox
            label="Afecta Contabilidad"
            id="afectaContabilidad"
            ref={chkAfectaConta}
            disabled={disabled}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoMotivoDesincorporacion
        show={mostrarCatalogo}
        onHide={onHideCatalogo}
      />
    </Modal>
  );
}
